import { render, staticRenderFns } from "./ProgressView.vue?vue&type=template&id=74d41ac4&lang=pug"
import script from "./ProgressView.vue?vue&type=script&lang=js"
export * from "./ProgressView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports